module.exports = __webpack_public_path__ + "img/sm.a731a170.svg";